module.exports = __webpack_public_path__ + "images/premium-74e2de852dbfa3958734501c19f6001c.jpg";